module.exports = __webpack_public_path__ + "static/media/dailyIcon1.78ea4d6f.svg";